const mutations = {
    VALIDATE_PAYMENT_MODAL(state, payload) {
        state.validatePaymentModal = payload || null;
    },
    CANCEL_ORDER_MODAL(state, order) {
        state.cancelOrderModal = order || null;
    },
    SHIPMENT_MODAL(state, shipment) {
        state.shipmentModal = shipment || null;
    },
    UPDATE_SHIPMENT_MODAL(state, shipment) {
        state.updateShipmentModal = shipment || null;
    },
    TRACKING_NUMBER_DRAWER(state, items) {
        state.trackingNumberDrawer = items || null;
    },

    UPDATE_SIDEBAR_COLLAPSE(state, statue) {
        const cname = 'sidebarCollapsed';
        const d = new Date();
        const cvalue = statue ? 1 : 0;

        d.setTime(d.getTime() + (10 * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

        // localStorage.setItem(cname, cvalue)

        state.sidebarCollapse = statue;
    },

    TEXT_EDITOR_DRAWER(state, content) {
        state.textEditorDrawer = content;
    },
    TEXT_EDITOR(state, content) {
        state.textEditor = content;
    },

    SET_segmentPersonnelModal(state, payload) {
        state.segmentPersonnelModel = payload;
    },
    APPLY_segmentPersonnelModal(state, payload) {
        state.applySegmentPersonnelModel = payload;
    },

    activeDesktopMenu(state, payload) {
        state.activeDesktopMenu = payload;
    },
    hasSearch(state, payload) {
        state.hasSearch = payload;
    },
    popMenu(state, payload) {
        state.popMenu = payload;
    },
    SET_POP_SHARE(state, payload) {
        state.popShare = payload;
    },

    SET_HOME_ABOUT_POP_VIDEO(state, payload) {
        state.homeAboutPopVideo = payload;
    }

}

export default mutations